const CLOUDFRONT_HOST_PATTERN = /cloudfront\.net/i;
const xhrRequestMeta = new WeakMap();
let installed = false;
let rplusEpubPreviewActive = false;

export function setRplusEpubCloudfrontCorsWorkaroundActive(active) {
  rplusEpubPreviewActive = Boolean(active);
}

const isCloudfrontAssetUrl = (url) => {
  if (url == null || url === '') {
    return false;
  }
  try {
    return CLOUDFRONT_HOST_PATTERN.test(String(url));
  } catch (error) {
    return false;
  }
};

const shouldStripCloudfrontCorsHeaders = (method, url) =>
  rplusEpubPreviewActive && String(method).toUpperCase() === 'GET' && isCloudfrontAssetUrl(url);

/**
 * R+ EPUB loads CloudFront pages via XHR/fetch with API headers (token, Accept, appId, …).
 * cert1 CloudFront fails CORS preflight for any custom header. PXE / new-tab use plain GETs.
 * Drop all custom headers on CloudFront GETs during R+ EPUB preview (all envs).
 */
export default function installCloudfrontCorsLocalWorkaround() {
  if (installed || typeof window === 'undefined') {
    return;
  }

  const XHR = window.XMLHttpRequest;
  if (typeof XHR !== 'undefined') {
    const { open, setRequestHeader } = XHR.prototype;

    XHR.prototype.open = function openWithUrl(method, url, ...rest) {
      xhrRequestMeta.set(this, {
        skipCloudfrontCorsHeaders: shouldStripCloudfrontCorsHeaders(method, url)
      });
      return open.call(this, method, url, ...rest);
    };

    XHR.prototype.setRequestHeader = function setRequestHeaderFiltered(name, value) {
      if (xhrRequestMeta.get(this)?.skipCloudfrontCorsHeaders) {
        return;
      }
      setRequestHeader.call(this, name, value);
    };
  }

  if (typeof window.fetch === 'function') {
    const nativeFetch = window.fetch.bind(window);
    window.fetch = (input, init) => {
      const url = typeof input === 'string' ? input : input?.url;
      const method = init?.method || (typeof input !== 'string' && input?.method) || 'GET';
      if (shouldStripCloudfrontCorsHeaders(method, url)) {
        const { headers, ...restInit } = init || {};
        return nativeFetch(input, restInit);
      }
      return nativeFetch(input, init);
    };
  }

  installed = true;
}
